// **********************************************************
// Accordion
// **********************************************************

attachEvent('.accordion__list-title', 'click', (ev) => {
  const parentElem = ev.target.closest('.accordion__list-item');
  const accordionContent = parentElem.querySelector('.accordion__table');
  parentElem.classList.toggle('is-open');
  slideToggle(accordionContent, 300, 'block');
});

// Toggle all accordions at once
attachEvent('.close-all-accordions', 'click', (ev) => {
  const parent = ev.target.closest('.accordion');

  const accordionItems = Array.from(parent.querySelectorAll('.accordion__list-item'));
  const atLeastOneOpen = accordionItems.some((item) => item.classList.contains('is-open'));

  accordionItems.forEach((item) => {
    if (atLeastOneOpen) {
      item.classList.remove('is-open');
      slideUp(item.querySelector('.accordion__table'), 300);
    } else {
      item.classList.add('is-open');
      slideDown(item.querySelector('.accordion__table'), 300, 'block');
    }
  });
});
